import { render, staticRenderFns } from "./regular_vehicle.vue?vue&type=template&id=38fe55d5"
import script from "./regular_vehicle.vue?vue&type=script&lang=js"
export * from "./regular_vehicle.vue?vue&type=script&lang=js"
import style0 from "./regular_vehicle.vue?vue&type=style&index=0&id=38fe55d5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports